import React, { useMemo } from 'react';
import { CustomComponentsProps, CustomComponentsWrapperType } from '@website-editor/customComponents';
import { WebsiteEditorVideoComponentFragment } from '@graphql/generated';
import { useAddVideoNavigations } from './hooks/useAddVideoNavigation';
import { createLazyComponentFromNamedExport } from '@shared/utils/createLazyComponent';
import { VideoEditListItem } from './wrappers/VideoEditListItem/VideoEditListItem';

// Lazy load sub-components
const VideoAddListItem = createLazyComponentFromNamedExport(
  () => import(/* webpackChunkName: "content/websiteEditorVideoAddListItem" */ './wrappers/VideoAddListItem/VideoAddListItem'),
  'VideoAddListItem',
);

const VideoForm = createLazyComponentFromNamedExport(() => import(/* webpackChunkName: "content/websiteEditorVideoForm" */ './components/VideoForm'), 'VideoForm');

export interface VideoProps
  extends CustomComponentsProps,
    Readonly<{
      componentData: WebsiteEditorVideoComponentFragment;
      isLastItem?: boolean;
    }> {}

export const Video: React.FC<VideoProps> = props => {
  const { wrapperType, componentData, ...restProps } = props;
  useAddVideoNavigations(props);

  const getRenderComponent = useMemo(() => {
    switch (wrapperType) {
      case CustomComponentsWrapperType.AddComponentList:
        return (
          <VideoAddListItem
            {...restProps}
            componentData={componentData}
          />
        );
      case CustomComponentsWrapperType.EditComponentList:
        return (
          <VideoEditListItem
            {...restProps}
            componentData={componentData}
          />
        );
      default:
        return (
          <VideoForm
            {...restProps}
            isEditMode
            isSingleComponent
          />
        );
    }
  }, [componentData, restProps, wrapperType]);

  return <>{getRenderComponent}</>;
};
